export const merge = images => {
    let formattedInput = images.map((image, index) => {
        if (index === 0) {
            return {
                src: image,
                x: 0,
                y: 0,
            };
        }

        return {
            src: image,
            x: 0,
            y: -100,
        };
    });
    return mergeImages(formattedInput);
};

export const urlToFile = (url, filename, type) => {
    return fetch(url)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], filename, { type }));
};

// Defaults
const defaultOptions = {
    format: 'image/png',
    quality: 0.92,
    width: undefined,
    height: undefined,
    Canvas: undefined,
};

// Return Promise
const mergeImages = (sources = [], options = {}) =>
    new Promise(resolve => {
        options = Object.assign({}, defaultOptions, options);

        // Setup browser/Node.js specific variables
        const canvas = options.Canvas ? new options.Canvas() : window.document.createElement('canvas');
        const Image = options.Canvas ? options.Canvas.Image : window.Image;
        if (options.Canvas) {
            options.quality *= 100;
        }

        // Load sources
        const images = sources.map(
            source =>
                new Promise((resolve, reject) => {
                    // Convert sources to objects
                    if (source.constructor.name !== 'Object') {
                        source = { src: source };
                    }

                    // Resolve source and img when loaded
                    // prettier-ignore
                    const img = new Image();
                    if (source.src.includes('https://')) {
                        img.crossOrigin = 'Anonymous';
                    }
                    img.onload = () => {
                        img.crossOrigin = 'Anonymous';
                        resolve(Object.assign({}, source, { img }));
                    };
                    img.onerror = e => {
                        reject(new Error("Couldn't load image"));
                    };
                    img.src = source.src;
                }),
        );

        // Get canvas context
        const ctx = canvas.getContext('2d');

        // When sources have loaded
        resolve(
            Promise.all(images).then(images => {
                // Set canvas dimensions
                const getSize = dim => options[dim] || Math.max(...images.map(image => image.img[dim]));
                canvas.width = getSize('width');
                canvas.height = getSize('height');

                // Draw images to canvas
                images.forEach(image => {
                    ctx.globalAlpha = image.opacity ? image.opacity : 1;
                    return ctx.drawImage(image.img, image.x || 0, image.y || 0);
                });

                if (options.Canvas && options.format === 'image/jpeg') {
                    // Resolve data URI for node-canvas jpeg async
                    return new Promise(resolve => {
                        canvas.toDataURL(
                            options.format,
                            {
                                quality: options.quality,
                                progressive: false,
                            },
                            (err, jpeg) => {
                                if (err) {
                                    throw err;
                                }
                                resolve(jpeg);
                            },
                        );
                    });
                }

                // Resolve all other data URIs sync
                return canvas.toDataURL(options.format, options.quality);
            }),
        );
    });



// WEBPACK FOOTER //
// ./src/Utils/mergeImages.js